interface useLocale {
  lang: Ref<string>;
  setLang: (locale: string) => void;
  locale: Ref<null | Locale>;
}

interface Locale {
  [key: string]: any;
}

export default async function (
  localeFile: string | null = null,
  key: string | null = null,
  extLocales: boolean = false,
): Promise<useLocale> {
  const lang = setStateValue("lang", "it");
  const locale = ref<null | Locale>(null);

  if (localeFile) {
    locale.value = await getLocale(localeFile, key, lang.value, extLocales);

    watch(lang, async (newLang) => {
      locale.value = await getLocale(localeFile, key, newLang, extLocales);
    });
  }

  const setLang = (locale: string) => {
    updateStateValue("lang", locale);
  };

  return {
    lang,
    setLang,
    locale,
  };
}
